import React, { useEffect, useState } from "react";
import styled from "styled-components";
import starEmptySvg from "../../../assets/images/star-border-white.svg";
import starFullSvg from "../../../assets/images/star-full-white.svg";
import { useFavoriteStateValue } from "../../../favorite/Favorite";

export const StyledFavButton = styled.button`
    && {
        background: transparent;
        border: none;
        background: ${({ isFavorite }) => (isFavorite ? `url(${starFullSvg})` : `url(${starEmptySvg})`)} no-repeat center;
        background-size: 20px;
        outline: none;
        height: 20px;
        width: 20px;
    }
`;

const FavoriteToggleButton = ({ id, renderItem: Component }) => {
    const { addToFavorites, removeFromFavorites, favoritePanels } = useFavoriteStateValue();
    const [favorite, setFavorite] = useState(false);
    const onClickHandler = event => {
        if (favorite) {
            setFavorite(false);
            removeFromFavorites(id);
        } else {
            setFavorite(true);
            addToFavorites(id);
        }
    };

    useEffect(() => {
        if (favoritePanels.includes(id)) {
            setFavorite(true);
        } else {
            setFavorite(false);
        }
    }, [favoritePanels, id]);

    return <Component isFavorite={favorite} onClick={onClickHandler} />;
};

export default FavoriteToggleButton;
